if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"webapp","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(6(28(63|91)|3880|8766|9536)|9(8670|9737|9882)|17548|2140|303|31369|40406|5323|59868|86285)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}